<template>
  <div class="cashflow-type-tracking-category card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :recommended-or-expected-amount="subtree.recommendedOrExpectedAmount"
                      :recommended-or-expected-label="titles.expenseProgress.recommendedLabel"
                      :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="subtree.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"
                      :out-of-date="true"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :recommended-title="titles.categorySections.recommendedTitle"
                                 :categories="subtree.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="true"
                                 :title="titles.categorySections.mainTitle"
                                 :out-of-date="true"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="false"
                                     :category-name="TRACKING_CATEGORY"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>

import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'CashflowTypeTrackingCategory',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,

  },
  props: [
    'subtree',
  ],
  computed: {
    CASHFLOW_TYPE() {
      return this.subtree.categoryName;
    },
    TRACKING_CATEGORY() {
      return cashflowViewConsts.cashflowTypes.trackingCategory;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'יצא עד עכשיו',
          recommendedLabel: 'סה"כ צפוי לצאת',
        },
        categorySections: {
          actualsTitle: 'יצא',
          recommendedTitle: 'צפוי לצאת',
          mainTitle: `הוצאות ${this.subtree.categoryName}`,
        },
        cardTitle: `הוצאות ${this.subtree.categoryName}`,
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .out-of-date-cashflow-view-container {
    .cashflow-type-tracking-category {
      @include cashflow-card;

      .title {
        color: $riseup_gray_2;
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_gray_2;
      }

      .cashflow-type-background-color {
        background-color: $riseup_gray_2;
      }
    }
  }
</style>
